
const updateFormTitle = (title) => ({
    type: "UPDATE_FORM_TITLE",
    payload: title,
  });
  export default updateFormTitle;